import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRolePermissions } from '@/hooks/useRolePermissions';

interface CrmCustomerWriteGuardProps {
  children: React.ReactNode;
}

export default function CrmCustomerWriteGuard({ children }: CrmCustomerWriteGuardProps): React.JSX.Element {
  const { canManageCrmCustomers } = useRolePermissions();

  if (!canManageCrmCustomers) {
    return <Navigate to="/crm/customers" replace />;
  }

  return <>{children}</>;
}
